import EventEmitter from "events";
const alertInstance = new EventEmitter();

export default alertInstance